import { SET_MESSAGE } from '../actions/type'

const initialState = {}

const reservation = (state = initialState, action) => {
    switch (action.type) {
        case SET_MESSAGE: {
            const payload = action.payload;
            return { ...state, ...payload };
        }
        default:
            return state
    }
}

export default reservation